module.exports = __webpack_public_path__ + "static/media/Logo-2026.da20ef6d.png";